import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const DisclaimerBanner = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-warning/10 border border-warning/20 rounded-xl p-4 md:p-5 lg:p-6">
      <div className="flex items-start gap-3">
        <div className="flex items-center justify-center w-10 h-10 bg-warning/20 rounded-lg flex-shrink-0">
          <Icon name="Info" size={20} color="var(--color-warning)" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm md:text-base font-semibold text-foreground mb-2">
            Önemli Bilgilendirme
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground leading-relaxed mb-3">
            Bu uygulama tarafından sağlanan varış süreleri <strong>tahmini</strong> değerlerdir ve gerçek zamanlı araç takibi içermemektedir.
          </p>
          
          {isExpanded && (
            <div className="space-y-3 mb-3">
              <div className="flex items-start gap-2">
                <Icon name="Clock" size={16} color="var(--color-muted-foreground)" className="flex-shrink-0 mt-0.5" />
                <p className="text-xs md:text-sm text-muted-foreground">
                  Tahminler, planlanan kalkış/varış saatleri ve rota geometrisine dayanmaktadır.
                </p>
              </div>
              <div className="flex items-start gap-2">
                <Icon name="TrendingUp" size={16} color="var(--color-muted-foreground)" className="flex-shrink-0 mt-0.5" />
                <p className="text-xs md:text-sm text-muted-foreground">
                  Trafik yoğunluğu, hava koşulları ve beklenmeyen durumlar gerçek varış sürelerini etkileyebilir.
                </p>
              </div>
              <div className="flex items-start gap-2">
                <Icon name="AlertTriangle" size={16} color="var(--color-muted-foreground)" className="flex-shrink-0 mt-0.5" />
                <p className="text-xs md:text-sm text-muted-foreground">
                  Yoğun saatlerde (07:30-09:30 ve 17:00-19:00) %20 ek süre hesaplanmaktadır.
                </p>
              </div>
              <div className="flex items-start gap-2">
                <Icon name="Shield" size={16} color="var(--color-muted-foreground)" className="flex-shrink-0 mt-0.5" />
                <p className="text-xs md:text-sm text-muted-foreground">
                  Lütfen seyahat planlarınızı yaparken bu tahminleri referans olarak kullanın ve ekstra süre ayırın.
                </p>
              </div>
            </div>
          )}

          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="flex items-center gap-2 text-xs md:text-sm font-medium text-warning hover:text-warning/80 transition-smooth"
          >
            <span>{isExpanded ? 'Daha Az Göster' : 'Daha Fazla Bilgi'}</span>
            <Icon 
              name={isExpanded ? "ChevronUp" : "ChevronDown"} 
              size={16} 
              color="var(--color-warning)" 
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerBanner;